module.exports = __webpack_public_path__ + "static/media/GregBloedorn2.415cf523.jpg";